import { MabComponent } from '@diekeure/components';
import { createInput, MountTarget, newDialog, readConfig } from './utils/elements';
import { registerHydrator } from './rehydrate';

export const MAB_EDIT_SELECTOR = '.cds-lrn-mab';

interface MabConfig {
  value: string;
  scratch: string;
}

registerHydrator(MAB_EDIT_SELECTOR, (cfg: MabConfig) => {
  const el: MabComponent = document.createElement('dk-mab') as MabComponent;
  el.setAttribute('value', cfg.value);
  el.setAttribute('scratch', cfg.scratch || '0');
  el.setAttribute('unitSize', '16');
  el.setAttribute('readonly', '');
  return el;
});

export function mabDialog(insertHtml: (html: string) => void, mountTarget?: MountTarget, existingEl?: HTMLElement) {
  const dialog = newDialog('MAB', () => insertHtml(''), mountTarget);

  const value = createInput('value', 'Getal', 'number');
  const scratch = createInput('scratch', 'Geschrapt', 'number');

  if (existingEl) {
    const cfg = readConfig<MabConfig>(existingEl, { value: '', scratch: '' });
    if (cfg.value) value.setValue(cfg.value);
    if (cfg.scratch) scratch.setValue(cfg.scratch);
  }

  dialog.querySelector('#cds-dialog-content').append(value.field, scratch.field);

  dialog.addEventListener('onSubmit', () => {
    const config: MabConfig = { value: value.value(), scratch: scratch.value() };
    const wrapper = document.createElement('div');
    wrapper.classList.add('cds-lrn-mab');
    wrapper.setAttribute('data-cb-config', JSON.stringify(config));
    insertHtml(wrapper.outerHTML);
  });
}

